import {TargetLineItem, NameInLineItem} from '@wix/auto_sdk_ecom_current-cart';
import {LineItem} from '@wix/auto_sdk_ecom_cart-v-2';

export class ViolationLineItemTargetModel {
  public id: string;
  public name?: ViolationLineItemTargetName;

  constructor(params: ViolationLineItemTargetModel) {
    this.id = params.id;
    this.name = params.name;
  }

  public static fromCartV1(lineItemTarget?: TargetLineItem) {
    return new ViolationLineItemTargetModel({
      id: lineItemTarget._id,
      name: lineItemTarget?.name && toViolationLineItemTargetName(lineItemTarget.name as NameInLineItem),
    });
  }
  /* istanbul ignore next */
  public static fromCartV2(lineItemTarget?: LineItem): ViolationLineItemTargetModel {
    return new ViolationLineItemTargetModel({
      id: lineItemTarget?._id,
      name: lineItemTarget?.name && toViolationLineItemTargetName(lineItemTarget.name as NameInLineItem),
    });
  }
}

export enum ViolationLineItemTargetName {
  default = 'LINE_ITEM_DEFAULT',
}

const toViolationLineItemTargetName = (name: NameInLineItem): ViolationLineItemTargetName => {
  const map: Record<NameInLineItem, ViolationLineItemTargetName> = {
    [NameInLineItem.LINE_ITEM_DEFAULT]: ViolationLineItemTargetName.default,
  };

  return map[name];
};
